import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { SpecialTarifsDetailsContent } from './components/SpecialTarifsDetailsContent';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetSingleCardCodeQuery } from '@/api/v2/cardCodes';
import { useAuthentication } from '@/hooks/useAuthentication';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const SpecialTarifsDetails: PageWithLayout = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const {
        liftOperatorData: { liftOperatorId },
    } = useAuthentication();
    const { data, isLoading } = useGetSingleCardCodeQuery({
        liftOperatorId,
        cardCodeId: id as string,
    });

    // no tarif found
    if (data === null) {
        navigate('/spezialtarife');
        return null;
    }

    if (isLoading) return null;

    return (
        <>
            <Helmet>
                <title>Spezialtarife Details | Starjack Admin</title>
            </Helmet>

            <SpecialTarifsDetailsContent cardCode={data} />
        </>
    );
};

SpecialTarifsDetails.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);

SpecialTarifsDetails.isProtected = true;
SpecialTarifsDetails.permissions = [Permission.EXTERNAL_CODES_NAV];

export default SpecialTarifsDetails;
